import React, { useEffect } from "react"
import withRouter from "components/Common/withRouter"
import { del } from "../../helpers/api_helper"
import { useNavigate, useParams } from "react-router-dom"
import { REMOVE_ARTICLE } from "helpers/api_endpoints"

function RemoveArticle() {
      const history = useNavigate()
      const params = useParams()
      const id = params.id
      const navigate = useNavigate()
      useEffect(() => {
        del(REMOVE_ARTICLE, { id })
          .then(response => {
            navigate("/articles", {
              state: { successMsg: "Article Deleted Successfully" },
            })
          })
          .catch(error => {
            console.log(error)
          })
      })
  return (
    <React.Fragment>Removed</React.Fragment>
  )
}

export default RemoveArticle